import React, { useState, useEffect, useMemo } from 'react';
import { useUnifyAdminStore } from '../../AdminStore';
import * as StyledComponents from '../StyledComponents';
import {
    BUTTON_VARIANTS,
    Button as RadialButton,
    INPUT_SIZES
} from 'cdk-radial';
import { AgGridReact } from "ag-grid-react";
import { ICellRendererParams, GridApi, ColumnApi } from 'ag-grid-community';
import { t } from 'i18next';

interface TabItem {
    id: string;
    panelId: string;
    renderPanel: any;
    renderTab: any;
}

export const BulkUploadedDataView = (): JSX.Element => {

    const updateCreateCampaignData = useUnifyAdminStore((state) => state.updateCreateCampaignData);
    const campaignItems = useUnifyAdminStore((state) => state.campaignItems);

    const gridEnterpriseData =  campaignItems.gridEnterpriseData;
    const gridStoresData =  campaignItems.gridStoresData;
    const gridEnterpriseSerachValue =  campaignItems.gridEnterpriseSerachValue || '';
    const gridStoresSearchValue =  campaignItems.gridStoresSearchValue || '' ;

    const [selectedEnterprises, setSelectedEnterprises] = useState(Array.isArray(gridEnterpriseData) ? gridEnterpriseData.filter((item: any) => item.isSelected): []) ;
    const [selectedStores, setSelectedStores] = useState(Array.isArray(gridStoresData) ? gridStoresData.filter((item: any) => item.isSelected): []);

    const onCellClickedEnterprises = (event: any) => {
        setSelectedEnterprises(Array.isArray(gridEnterpriseData) ? gridEnterpriseData.filter((item: any) => item.isSelected) : []);
        updateCreateCampaignData({
            fieldName: 'targetEnterprises',
            value: gridEnterpriseData
                ?.filter(item => item.isSelected)
                .map(item => item.name)
                .join(",") || "",
        });
    }

    const onCellClickedStores = (event: any) => {
        setSelectedStores(Array.isArray(gridStoresData) ? gridStoresData.filter((item) => item.isSelected) : []);
        updateCreateCampaignData({
            fieldName: 'targetStores',
            value: gridStoresData
                ?.filter(item => item.isSelected)
                .map(item => item.name)
                .join(",")|| "",
        });
    }

    const onEnterpriseDeleteData = () => {
        updateCreateCampaignData({
            fieldName: 'uploadedEnterprises',
            value: '',
        });
        updateCreateCampaignData({
            fieldName: 'targetEnterprises',
            value: '',
        });

        updateCreateCampaignData({
            fieldName: 'gridEnterpriseData',
            value: [],
        });
        setSelectedEnterprises([]);
    };

    const onStoresDeleteData = () => {
        updateCreateCampaignData({
            fieldName: 'uploadedStores',
            value: '',
        });
  
        updateCreateCampaignData({
            fieldName: 'targetStores',
            value: '',
        });

        updateCreateCampaignData({
            fieldName: 'gridStoresData',
            value: [],
        });

        setSelectedStores([]);
    };

    const [activeItemIndex, setActiveItemIndex] = React.useState(0);

    const columnDefEnterprises = useMemo(() => [
        {
            width: 60,
            headerName: "",
            field: "isSelected",
            cellRenderer: (params: ICellRendererParams) => (
                <input
                    type="checkbox"
                    checked={params.value}
                    onChange={() => {
                        params.node.setDataValue('isSelected', !params.value)
                    }}
                />
            )
        },
        {
            headerName: t('campaigns.enterpriseId'),
            field: "name",
            flex: 1
        }
    ], []);


    const columnDefStores = useMemo(() => [
        {
            width: 60,
            headerName: "",
            field: "isSelected",
            cellRenderer: (params: ICellRendererParams) => (
                <input
                    type="checkbox"
                    checked={params.value}
                    onChange={() => {
                        setSelectedStores(Array.isArray(gridStoresData) ? gridStoresData.filter((item) => item.isSelected) : []);
                        params.node.setDataValue('isSelected', !params.value)
                    }}
                />
            )
        },
        {
            headerName: t('campaigns.stores'),
            field: "name",
            flex: 1
        }
    ], [gridStoresData]);

    const handleEnterpriseChangeSearchValue = (e: string) => {
        updateCreateCampaignData({
            fieldName: 'gridEnterpriseSerachValue',
            value: e,
        });
    }

    const handleStoresChangeSearchValue = (e: string) => {
        updateCreateCampaignData({
            fieldName: 'gridStoresSearchValue',
            value: e,
        });
    }
  
    let tabs: TabItem[] = [];

    tabs.push({
        id: 'tab-1',
        panelId: 'panel-1',
        renderPanel: (props: any) => (
            <StyledComponents.StyledTabPanel {...props}>
                <div style={{ width: '390px' }}>
                    <div style={{ display: 'inline-flex', width: '100%', height:'40px' }}>
                        <StyledComponents.StyledSearchBoxCampaign
                            dataTestId="camp-enterprise-search-input"
                            className="customize-search-input"
                            clearButtonLabel="clearButtonLabel"
                            id="camp-enterprise-search-input"
                            isAlwaysExpanded
                            name="camp-enterprise-search-input"
                            onChange={(e: string) => handleEnterpriseChangeSearchValue(e)}
                            placeholder={t('gridHeader.search')}
                            size={INPUT_SIZES.STANDARD}
                            value={gridEnterpriseSerachValue}
                        />
                        <RadialButton text={t('campaigns.deleteAllButton')} style={{ color: "#006CFA", marginLeft: '20%', fontSize: '12px', marginTop: '20px', whiteSpace: 'nowrap'}} onClick={onEnterpriseDeleteData} variant={BUTTON_VARIANTS.TEXT} >
                        </RadialButton>
                    </div>
                    <StyledComponents.StyledTableContainerEnterprises>
                        <StyledComponents.StyledTableWrapper className="ag-theme-alpine">
                            <AgGridReact
                                rowData={campaignItems.gridEnterpriseData}
                                columnDefs={columnDefEnterprises}
                                rowSelection="multiple"
                                suppressRowClickSelection={false}
                                pagination={true}
                                paginationPageSize={10}
                                onCellClicked={onCellClickedEnterprises}
                                onGridReady={onGridEnterprisesReady}
                            />
                        </StyledComponents.StyledTableWrapper>
                    </StyledComponents.StyledTableContainerEnterprises>
                    <div style={{ fontSize: '12px', marginLeft: '10px' }}>{selectedEnterprises?.length} {t('campaigns.selectedOf')} {gridEnterpriseData?.length} {t('campaigns.enterprises')}</div>
                </div>
            </StyledComponents.StyledTabPanel>
        ),
        renderTab: (props: any) => (
            <StyledComponents.StyledInnerTab
                label={t('campaigns.enterprises')}
                {...props}
            />
        ),
    });

    tabs.push({
        id: 'tab-2',
        panelId: 'panel-2',
        renderPanel: (props: any) => (
            <StyledComponents.StyledTabPanel {...props}>
                <div style={{ width: '400px'}}>
                    <div style={{ display: 'inline-flex', width: '100%' }}>
                        <StyledComponents.StyledSearchBoxCampaign
                            dataTestId="camp-store-search-input"
                            className="customize-search-input"
                            clearButtonLabel="clearButtonLabel"
                            id="camp-store-search-input"
                            isAlwaysExpanded
                            name="camp-store-search-input"
                            onChange={(e: string) => handleStoresChangeSearchValue(e)}
                            placeholder={t('gridHeader.search')}
                            size={INPUT_SIZES.STANDARD}
                            value={gridStoresSearchValue}
                        />
                        <RadialButton text={t('campaigns.deleteAllButton')} style={{ color: "#006CFA", marginLeft: '20%', fontSize: '12px', marginTop: '20px', whiteSpace: 'nowrap'}} onClick={onStoresDeleteData} variant={BUTTON_VARIANTS.TEXT} >
                        </RadialButton>
                    </div>
                    <StyledComponents.StyledTableContainerStores>
                        <StyledComponents.StyledTableWrapper className="ag-theme-alpine">
                            <AgGridReact
                                rowData={campaignItems.gridStoresData}
                                columnDefs={columnDefStores}
                                rowSelection="multiple"
                                suppressRowClickSelection={false}
                                pagination={true}
                                paginationPageSize={10}
                                onCellClicked={onCellClickedStores}
                                onGridReady={onGridStoresReady}
                            />
                        </StyledComponents.StyledTableWrapper>
                    </StyledComponents.StyledTableContainerStores>
                    <div style={{ fontSize: '12px', marginLeft: '10px' }}>{selectedStores?.length} {t('campaigns.selectedOf')} {gridStoresData?.length} {t('campaigns.stores')}</div>
                </div>
            </StyledComponents.StyledTabPanel>
        ),
        renderTab: (props: any) => (
            <StyledComponents.StyledInnerTab
                label={t('campaigns.stores')}
                {...props}
            />
        ),
    });

    const [enterpriseGridApi, setEnterpriseGridApi] = useState<GridApi>();
    const onGridEnterprisesReady = (params: { api: GridApi; columnApi: ColumnApi }) => {
        setEnterpriseGridApi(params.api);
    };
    useEffect(() => {
        if (enterpriseGridApi) {
            enterpriseGridApi.setQuickFilter(gridEnterpriseSerachValue);
        }
    }, [gridEnterpriseSerachValue, enterpriseGridApi]);

    const [storesGridApi, setStoresGridApi] = useState<GridApi>();
    const onGridStoresReady = (params: { api: GridApi; columnApi: ColumnApi }) => {
        setStoresGridApi(params.api);
    };
    useEffect(() => {
        if (storesGridApi) {
            storesGridApi.setQuickFilter(gridStoresSearchValue);
        }
    }, [gridStoresSearchValue, storesGridApi]);

    return (
        <div style={{ height: '67vh', width: '27vw', paddingRight:'5px', paddingTop:'12px' }}>
            <StyledComponents.StyledTabs
                activeItemIndex={activeItemIndex}
                alignment="left"
                items={tabs}
                onActiveItemChange={setActiveItemIndex}
                tabsLabel=""
            />
        </div>
    );
};
